<template>
    <span class="pr-2 flex items-center" >
        <slot></slot>
        <abbr class="ml-2 whitespace-no-wrap" 
        :class="[ isSideNavCollapsed ? 'hidden' : 'inline-block']">{{ title }}</abbr>
    </span>
</template>

<script>
    export default {
          props: ['title'],
          computed: {
            isSideNavCollapsed() {
              return this.$store.getters.isSideNavCollapsed;
              },
          },
    }
</script>

<style lang="scss" scoped>

</style>